<template>
  <main>
    <v-container>
      <v-row>
        <v-col>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card outlined>
              <!-- Tabs -->
              <v-tabs v-model="tab" background-color="primary" dark show-arrows>
                <v-tab>Details</v-tab>
                <v-tab>Module Builder</v-tab>
              </v-tabs>

              <!-- Tab Items -->
              <v-tabs-items v-model="tab" class="py-4 px-4">
                <v-tab-item :transition="false" :reverse-transition="false">
                  <v-text-field v-model="formData.name" label="Name" :required="true" :rules="rules.name" />
                  <v-text-field v-model="formData.title" label="Title" />
                </v-tab-item>
                <v-tab-item :transition="false" :reverse-transition="false">
                  <v-expansion-panels v-model="fieldPanel" class="mb-4" multiple>
                    <v-draggable v-model="formData.fields" style="width: 100%;">
                      <v-expansion-panel v-for="(field, index) in formData.fields" :key="index" flat>
                        <v-expansion-panel-header>
                          <div class="d-flex align-center">
                            <v-btn icon class="mr-2" @click.prevent="removeField(index)">
                              <v-icon>delete_outline</v-icon>
                            </v-btn>
                            <div class="text-capitalize">
                              <v-chip color="primary mr-2">{{ field.type }} Field</v-chip>
                              <span class="mr-2">{{ field.title || field.key }}</span>
                              <span v-if="field.required" class="red--text">*</span>
                            </div>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-text-field v-model="field.title" label="Title" />
                          <v-text-field v-model="field.key" label="Key" :required="true" :rules="rules.field.key" />
                          <v-checkbox v-model="field.required" label="Required Field" />
                          <v-checkbox v-if="field.type === 'select'" v-model="field.dynamic" label="Dynamic Data" />
                          <v-select
                            v-if="field.type === 'select' && field.dynamic"
                            v-model="field.dynamicKey"
                            :items="dynamicSelectItems"
                            label="Dynamic Data"
                            item-text="key"
                            item-value="value"
                            required
                          />
                          <v-card v-else-if="field.type === 'select' && !field.dynamic" class="mb-4" outlined>
                            <v-simple-table>
                              <template #default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Text</th>
                                    <th class="text-left">Value</th>
                                    <th class="text-right"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(option, key) in field.options || []" :key="key">
                                    <td>
                                      <v-text-field v-model="option.text" :rules="rules.option.text" required />
                                    </td>
                                    <td>
                                      <v-text-field v-model="option.value" :rules="rules.option.value" required />
                                    </td>
                                    <td class="text-right">
                                      <v-btn icon @click.prevent="removeOption(index, key)">
                                        <v-icon>delete_outline</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <hr />
                            <v-card-actions class="mt-4">
                              <v-spacer />
                              <v-btn color="primary" depressed @click.prevent="addOption(index)">
                                <span>Add Value</span>
                              </v-btn>
                            </v-card-actions>
                          </v-card>

                          <div v-if="field.fields">
                            <v-expansion-panels
                              v-if="field.fields.length > 0"
                              v-model="innerFieldPanel"
                              class="mb-4"
                              multiple
                            >
                              <v-draggable v-model="field.fields" style="width: 100%;">
                                <v-expansion-panel v-for="(innerField, key) in field.fields" :key="key" flat>
                                  <v-expansion-panel-header>
                                    <div class="d-flex align-center">
                                      <v-btn icon class="mr-2" @click.prevent="removeField(index, key)">
                                        <v-icon>delete_outline</v-icon>
                                      </v-btn>
                                      <span class="text-capitalize">
                                        {{ innerField.title || innerField.key || `${innerField.type} Field` }}
                                      </span>
                                    </div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-text-field v-model="innerField.title" label="Title" />
                                    <v-text-field
                                      v-model="innerField.key"
                                      label="Key"
                                      :required="true"
                                      :rules="rules.field.key"
                                    />
                                    <v-checkbox v-model="innerField.required" label="Required Field" />
                                    <v-checkbox
                                      v-if="innerField.type === 'select'"
                                      v-model="innerField.dynamic"
                                      label="Dynamic Data"
                                    />
                                    <v-select
                                      v-if="innerField.type === 'select' && innerField.dynamic"
                                      v-model="innerField.dynamicKey"
                                      :items="dynamicSelectItems"
                                      label="Dynamic Data"
                                      item-text="key"
                                      item-value="value"
                                      required
                                    />

                                    <v-card
                                      v-else-if="innerField.type === 'select' && !field.dynamic"
                                      class="mb-4"
                                      outlined
                                    >
                                      <v-simple-table>
                                        <template #default>
                                          <thead>
                                            <tr>
                                              <th class="text-left">Text</th>
                                              <th class="text-left">Value</th>
                                              <th class="text-right"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(option, key) in innerField.options || []" :key="key">
                                              <td>
                                                <v-text-field
                                                  v-model="option.text"
                                                  :rules="rules.option.text"
                                                  required
                                                />
                                              </td>
                                              <td>
                                                <v-text-field
                                                  v-model="option.value"
                                                  :rules="rules.option.value"
                                                  required
                                                />
                                              </td>
                                              <td class="text-right">
                                                <v-btn icon @click.prevent="removeOption(index, key)">
                                                  <v-icon>delete_outline</v-icon>
                                                </v-btn>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                      <hr />
                                      <v-card-actions class="mt-4">
                                        <v-spacer />
                                        <v-btn color="primary" depressed @click.prevent="addOption(index)">
                                          <span>Add Value</span>
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-draggable>
                            </v-expansion-panels>
                            <v-menu
                              bottom
                              right
                              allow-overflow
                              offset-y
                              nudge-bottom="20"
                              nudge-width="300"
                              max-height="400"
                              transition="slide-y-transition"
                              :close-on-content-click="false"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" depressed v-bind="attrs" v-on="on">
                                  <span>Add Field</span>
                                </v-btn>
                              </template>

                              <v-list>
                                <v-list-item
                                  v-for="(fieldType, fieldTypeKey) in fields.filter(field => field.type !== 'flexible')"
                                  :key="fieldTypeKey"
                                  link
                                  @click="addField(fieldType, index)"
                                >
                                  <v-list-item-title v-text="fieldType.title" />
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-draggable>
                  </v-expansion-panels>
                  <v-menu
                    bottom
                    right
                    allow-overflow
                    offset-y
                    nudge-bottom="20"
                    nudge-width="300"
                    max-height="400"
                    transition="slide-y-transition"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" depressed v-bind="attrs" v-on="on">
                        <span>Add Field</span>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item v-for="(field, index) in fields" :key="index" link @click="addField(field)">
                        <v-list-item-title v-text="field.title" />
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col class="d-flex items-center justify-end">
          <v-btn :loading="loading.cancelling" :disabled="disabled" class="mr-4" text @click="cancelCreatingResource">
            Cancel
          </v-btn>
          <v-btn
            :loading="loading.creatingAlt"
            :disabled="disabled"
            class="mr-4"
            color="primary"
            @click="createResourceWithoutRedirect"
          >
            Create & Add Another
          </v-btn>
          <v-btn :loading="loading.creating" :disabled="disabled" color="primary" @click="createResourceWithRedirect">
            Create {{ resourceType }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import PermissionsHandler from '@/mixins/permissions-handler'
import CreateResource from '@/mixins/create-resource'

export default {
  name: 'ModulesCreate',
  mixins: [PermissionsHandler, CreateResource],
  data() {
    return {
      fieldPanel: [],
      innerFieldPanel: [],
      resourceType: 'Module',
      resourcePrefix: 'modules',
      rules: {
        name: [v => !!v || 'Name is required', v => (!!v && v.length > 0) || 'Name must be greater than 0'],
        field: {
          key: [v => !!v || 'Key is required', v => (!!v && v.length > 0) || 'Key must be greater than 0'],
        },
        option: {
          text: [v => !!v || 'Text is required', v => (!!v && v.length > 0) || 'Text must be greater than 0'],
          value: [v => !!v || 'Value is required', v => (!!v && v.length > 0) || 'Value must be greater than 0'],
        },
      },
      formData: {
        name: null,
        title: null,
        fields: [],
      },
      dynamicSelectItems: [
        { key: 'Categories', value: 'categories' },
        { key: 'Modules', value: 'modules' },
        // @note - to add more dynamic select options add the key of the select item here...
      ],
      fields: [
        {
          title: 'Text Area Field',
          type: 'textarea',
        },
        {
          title: 'Text Field',
          type: 'text',
        },
        {
          title: 'Froala Field',
          type: 'froala',
        },
        {
          title: 'Image Field',
          type: 'image',
        },
        {
          title: 'Flexible Field',
          type: 'flexible',
        },
        {
          title: 'Boolean Field',
          type: 'boolean',
        },
        {
          title: 'Hidden Field',
          type: 'hidden',
        },
        {
          title: 'Select Field',
          type: 'select',
        },
        {
          title: 'Number Field',
          type: 'number',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      resource: 'modules/getModule',
    }),
  },
  methods: {
    ...mapActions({
      create: 'modules/create',
    }),
    addField(field, fieldIndex = null) {
      const obj = { key: null, type: field.type, title: null, required: false }
      if (field.type === 'flexible') obj.fields = []
      if (fieldIndex === null) return this.formData.fields.push(obj)
      this.formData.fields[fieldIndex].fields.push(obj)
    },
    removeField(index, innerFieldIndex = null) {
      if (innerFieldIndex === null) return this.formData.fields.splice(index, 1)
      this.formData.fields[index].fields.splice(innerFieldIndex, 1)
    },
    addOption(index) {
      const option = { text: null, value: null }
      if (!this.formData.fields[index].options) this.$set(this.formData.fields[index], 'options', [])
      this.formData.fields[index].options.push(option)
    },
    removeOption(index, key) {
      this.formData.fields[index].options.splice(key, 1)
    },
    async createResource() {
      return await this.create({ formData: this.formData })
    },
  },
}
</script>
